import { useState } from 'react';
import { map } from '../../../../../common/redux/reducer/commonSlices/mapSlice';
import { findAddress } from '../../../../../utils/commonFunctions';
import {
  updateFence,
  updateFenceById,
  updateIsShow
} from '../../../../../common/redux/reducer/commonSlices/circleSlice';

export const useGeofenceGooglemap = ({
  fences,
  dispatch,
  setValue,
  clearErrors,
  filteredRow
}: any) => {
  const [toggleLock, setToggleLock] = useState<boolean>(false);
  const [address, setAddress] = useState<any>(null);
  const [mapClick, setMapClick] = useState<any>();

  const handleLockIcon = () => {
    setToggleLock(!toggleLock);
  };

  const handleMapClick = async (e: any) => {
    if (mapClick === 'circular') {
      const lat = e?.latLng?.lat();
      const lng = e?.latLng?.lng();
      let center = { lat, lng };

      dispatch(map([{ id: 1, lat, lng, name: 'myplace' }]));

      const fAdd = await findAddress(lat, lng);
      setAddress({
        geometry: {
          location: {
            lat: e?.latLng?.lat,
            lng: e?.latLng?.lng
          }
        },
        formatted_address: fAdd
      });
      setValue('radius', filteredRow?.radius * 1000);
      clearErrors('radius');
      const circularFences = fences
        ?.map((item: any) => item?.id)
        ?.includes(filteredRow?.geoZoneId);

      if (filteredRow && circularFences) {
        dispatch(
          updateFenceById({
            id: filteredRow?.geoZoneId,
            center,
            radius: filteredRow?.radius * 1000
          })
        );
      } else {
        const geofences = fences;
        const updatedFences = [
          ...(new Map(
            [...geofences, { id: 'new', center, radius: 1000 }]?.map((item: any) => [
              item['id'],
              item
            ])
          ).values() as any)
        ];
        dispatch(updateFence(updatedFences));
      }
      dispatch(updateIsShow(true));
    }
  };

  return {
    handleLockIcon,
    toggleLock,
    setToggleLock,
    handleMapClick,
    setMapClick,
    setAddress,
    address,
    mapClick
  };
};
